export function getEnvironment() {
    const env = import.meta.env
    return { ENV: env.MODE, isDev: env.DEV, isBuild: env.PROD, ...env };
}